<div
  class="iotnet-map"
  leaflet
  [leafletOptions]="options"
  [leafletLayers]="markers()"
  [leafletFitBounds]="fitBounds()"
  [leafletFitBoundsOptions]="fitBoundsOptions"
  (leafletMapReady)="onMapReady($event)"
></div>

<iotnet-gateway-filter
  class="map-filter"
  [(activeStatuses)]="activeStatuses"
  [availableTags]="availableTags()"
  [(activeTags)]="activeTags"
/>

<iotnet-map-info class="map-info" />

<button
  type="button"
  class="list-toggle"
  [class.list-toggle--open]="listExpanded()"
  [attr.aria-expanded]="listExpanded()"
  [title]="'Iotnet.GatewayList' | translate"
  (click)="toggleList()"
>
  <svg-icon src="assets/images/icons/iotnet.svg"></svg-icon>
</button>

@if (listExpanded()) {
  <div class="gateway-list">
    <div class="gateway-list__search input__wrapper">
      <input
        type="search"
        [(ngModel)]="gatewaySearch"
        class="input input--search"
        name="gateway-search"
        placeholder="{{ 'Iotnet.SearchGateways' | translate: { count: gateways().length } }}"
      />
    </div>

    <div class="gateway-list__items">
      @for (gateway of filteredGateways(); track gateway.gateway_id) {
        <iotnet-gateway-element
          [gateway]="gateway"
          [active]="isSelected(gateway)"
          (selected)="zoomToGateway($event)"
          (deselected)="selectedGateway.set(null)"
        ></iotnet-gateway-element>
      }
    </div>
  </div>
}
